const STORAGE_KEY = "ge3s.company.branding";

export function readCompanyBranding() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { companyLogo: "", companyName: "" };
    const parsed = JSON.parse(raw);
    return {
      companyLogo: parsed?.companyLogo || "",
      companyName: parsed?.companyName || "",
    };
  } catch {
    return { companyLogo: "", companyName: "" };
  }
}

export function saveCompanyBranding(branding = {}) {
  const existing = readCompanyBranding();
  const incomingLogo =
    typeof branding.companyLogo === "string" ? branding.companyLogo.trim() : "";
  const incomingName =
    typeof branding.companyName === "string" ? branding.companyName.trim() : "";

  const nextLogo = incomingLogo || existing.companyLogo || "";
  const nextName = incomingName || existing.companyName || "";

  if (!nextLogo && !nextName) return;

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      companyLogo: nextLogo,
      companyName: nextName,
      updatedAt: new Date().toISOString(),
    }),
  );
  window.dispatchEvent(new CustomEvent("ge3s:company-branding-updated"));
}

export function clearCompanyBranding() {
  localStorage.removeItem(STORAGE_KEY);
}
